/* eslint-disable */

<template>
  <div class="vx-row">
    <div class="vx-col bg-dark rounded-lg main-border mb-base mx-4 p-0">
      <div class="flex md:flex-row sm:flex-col">
        <div class="flex flex-col md:w-1/2 md:main-right-border p-6 sm:w-full">
          <span class="flex items-center gap-3 mb-1">
            <vs-button v-if="canShowHelp" color="grey" size="small" @click="isViewingWeakPasswordHelp = true">Help</vs-button>
            <h4 class="font-normal">Identity weak password practices</h4>
          </span>
          <p class="text-grey">(select all that apply)</p>

          <div class="flex flex-wrap gap-4 mt-4">
            <vs-checkbox v-model="weakPasswordQuestion.value" class="mr-4" vs-value="Age">Age</vs-checkbox>
            <vs-checkbox v-model="weakPasswordQuestion.value" class="mr-4" vs-value="Expiration">Expiration</vs-checkbox>
            <vs-checkbox v-model="weakPasswordQuestion.value" class="mr-4" vs-value="Reuse">Reuse</vs-checkbox>
            <vs-checkbox v-model="weakPasswordQuestion.value" class="mr-4" vs-value="Complexity">Complexity</vs-checkbox>
            <vs-checkbox v-model="weakPasswordQuestion.value" class="mr-4" vs-value="Length">Length</vs-checkbox>
          </div>
        </div>

        <div class="flex flex-col md:w-1/2 p-6 sm:w-full">
          <span class="flex gap-3 mb-1">
            <vs-button v-if="canShowHelp" color="grey" size="small" class="h-fit flex-shrink-0" @click="isViewingContainmentHelp = true"
              >Help</vs-button
            >
            <h4 class="font-normal">Select the containment step that will leave potential evidence on the host uncompromised:</h4>
          </span>

          <div class="flex flex-wrap gap-4 mt-4">
            <vs-radio v-model="containmentQuestion.value" class="mr-4" vs-value="PIN code">PIN code</vs-radio>
            <vs-radio v-model="containmentQuestion.value" class="mr-4" vs-value="FIDO security key">FIDO security key</vs-radio>
            <vs-radio v-model="containmentQuestion.value" class="mr-4" vs-value="SMS authentication">SMS authentication</vs-radio>
            <vs-radio v-model="containmentQuestion.value" class="mr-4" vs-value="OTP token">OTP token</vs-radio>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-col">
      <div class="w-full flex justify-center relative click-item-container">
        <div class="image-container flex items-center" style="position: relative">
          <img
            src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02727378374626738439046/graphic.png"
            draggable="false"
            width="1293"
            height="898"
            style="width: 100%; height: 100%"
          />

          <!-- SUBNET ONE -->
          <div class="flex flex-col absolute" style="right: 30%; top: 23.5%">
            <vs-button color="primary" size="small" type="border" @click="isViewingDirectory = true">Preview</vs-button>
          </div>

          <div class="flex flex-col absolute" style="right: 30%; top: 32.3%">
            <vs-button color="primary" size="small" type="border" @click="isViewingCompensationReport = true">Preview</vs-button>
          </div>

          <div class="flex flex-col absolute" style="right: 30%; top: 41%">
            <vs-button color="primary" size="small" type="border" @click="isViewingUserData = true">Preview</vs-button>
          </div>
        </div>
      </div>

      <movable-popup
        refVal="directoryRef"
        title="Directory Contents - Click Here to Drag This Popup"
        :active="isViewingDirectory"
        v-on:close="isViewingDirectory = false"
        padding="0px"
      >
        <template v-slot:content>
          <div class="bg-dark p-3 main-border rounded-lg">
            <span class="terminal-line text-grey" style="line-height: 2rem" v-html="directoryContents" />
          </div>
        </template>
      </movable-popup>

      <movable-popup
        refVal="compensationRef"
        title="Compensation Report - Click Here to Drag This Popup"
        :active="isViewingCompensationReport"
        v-on:close="isViewingCompensationReport = false"
        padding="0px"
      >
        <template v-slot:content>
          <div class="bg-dark p-3 main-border rounded-lg flex flex-col">
            <div class="grid grid-cols-5 gap-6 font-medium pb-2">
              <span style="line-height: 2rem">Username</span>
              <span style="line-height: 2rem">Hire Date</span>
              <span style="line-height: 2rem">Physical Address</span>
              <span style="line-height: 2rem">Last Active</span>
              <span style="line-height: 2rem">Salary</span>
            </div>

            <div class="grid gap-x-6 gap-y-2">
              <span
                class="terminal-line text-grey grid grid-cols-5 gap-6 py-2 main-top-border"
                style="line-height: 2rem"
                v-for="(item, index) in compensationReportContents"
                :key="index"
              >
                <span>{{ item[0] }}</span>
                <span>{{ item[1] }}</span>
                <span>{{ item[2] }}</span>
                <span>{{ item[3] }}</span>
                <span>{{ item[4] }}</span>
              </span>
            </div>
          </div>
        </template>
      </movable-popup>

      <movable-popup
        refVal="userDataRef"
        title="User Data - Click Here to Drag This Popup"
        :active="isViewingUserData"
        v-on:close="isViewingUserData = false"
        padding="0px"
      >
        <template v-slot:content>
          <div class="bg-dark p-3 main-border rounded-lg flex flex-col">
            <div class="grid grid-cols-5 gap-6 font-medium pb-2">
              <span style="line-height: 2rem">Username</span>
              <span style="line-height: 2rem">Password</span>
              <span style="line-height: 2rem">IP Address (Lat Login)</span>
              <span style="line-height: 2rem">Last Active</span>
              <span style="line-height: 2rem">Last Password Change</span>
            </div>

            <div class="grid gap-x-6 gap-y-2">
              <span
                class="terminal-line text-grey grid grid-cols-5 gap-6 py-2 main-top-border"
                style="line-height: 2rem"
                v-for="(item, index) in userDataContents"
                :key="index"
              >
                <span>{{ item[0] }}</span>
                <span>{{ item[1] }}</span>
                <span>{{ item[2] }}</span>
                <span>{{ item[3] }}</span>
                <span>{{ item[4] }}</span>
              </span>
            </div>
          </div>
        </template>
      </movable-popup>

      <movable-popup
        refVal="weakPasswordHelpRef"
        title="Weak Password Practices Help - Click Here to Drag This Popup"
        :active="isViewingWeakPasswordHelp"
        v-on:close="isViewingWeakPasswordHelp = false"
        padding="0px"
      >
        <template v-slot:content>
          <div class="bg-dark p-3 main-border rounded-lg flex flex-col gap-3">
            <span class="space-x-1">
              <span class="mr-1">•</span>
              <span>Age –</span>
              <span class="text-grey"
                >several passwords haven’t been changed in years (e.g. April’s last change was 5/8/2012, Walter’s 1/5/2013).
              </span>
            </span>

            <span class="space-x-1">
              <span class="mr-1">•</span>
              <span>Expiration –</span>
              <span class="text-grey">there’s no effective expiration policy, so users aren’t forced to rotate passwords. </span>
            </span>

            <span class="space-x-1">
              <span class="mr-1">•</span>
              <span>Complexity –</span>
              <span class="text-grey"
                >many passwords are simple dictionary words or predictable phrases (“pword”, “starwars”, “football2015”).</span
              >
            </span>

            <span class="space-x-1">
              <span class="mr-1">•</span>
              <span>Length –</span>
              <span class="text-grey">some are very short or lack sufficient entropy to resist brute-force attacks.</span>
            </span>

            <h5 class="text-md mt-3">❌ Reuse isn’t evident (each account has a unique password), so you don’t need to check that box.</h5>
          </div>
        </template>
      </movable-popup>

      <movable-popup
        refVal="containmentHelpRef"
        title="Containment Help - Click Here to Drag This Popup"
        :active="isViewingContainmentHelp"
        v-on:close="isViewingContainmentHelp = false"
        padding="0px"
      >
        <template v-slot:content>
          <div class="bg-dark p-3 main-border rounded-lg flex flex-col gap-3">
            <span class="text-grey">
              This approach does not require installing software or changing host configurations, so you preserve any forensic evidence on
              the endpoint.
            </span>

            <span class="text-grey">Implement <span class="text-white">FIDO security keys</span> for employees.</span>

            <span class="text-grey">
              A FIDO security key is a small hardware device, often resembling a USB drive, that enables passwordless and phishing-resistant
              authentication for online accounts. It utilizes public key cryptography to securely verify a user's identity, eliminating the
              need for passwords or relying on less secure methods like SMS codes.
            </span>

            <span class="text-grey"> Most secure among listed options. </span>
            <span class="text-grey"
              >Hardware-based; resistant to phishing, interception, and does not leave evidence on the compromised host (which is important
              for forensics).
            </span>

            <span class="text-grey"
              >The most secure solution for account protection among these, that also doesn’t interfere with host evidence, is
              <span class="text-white">FIDO security key</span>.
            </span>

            <span class="my-4">
              <span class="font-medium text-lg">Why?</span><br />
              <span class="text-grey"><span class="text-white">PIN Code:</span> Not strong enough; also may be stored locally.</span><br />
              <span class="text-grey"
                ><span class="text-white">SMS authentication:</span> Can be intercepted; often leaves traces on the host (like SMS
                logs).</span
              ><br />
              <span class="text-grey"><span class="text-white">OTP token:</span> Similar risks, some implementation might log the AI.</span
              ><br />
              <span class="text-grey"
                ><span class="text-white">FIDO security key:</span> Hardware-based, phishing-resistant, no codes sent to the host, and
                doeesn't alter host evidence—authentication happens off the device.</span
              ><br />
            </span>

            <div>
              <span class="text-xl">So, the best answer is:</span><br />
              <span class="text-grey text-xl">FIDO security key</span>
            </div>
          </div>
        </template>
      </movable-popup>
    </div>
  </div>
</template>

<script>
import MovablePopup from '../../../../../../../../components/popup/MovablePopup';
import LottieAnimation from '../../../../../../../../components/lottie/LottieAnimation';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,
      isViewingDirectory: false,
      isViewingCompensationReport: false,
      isViewingUserData: false,

      canShowHelp: false,
      isViewingWeakPasswordHelp: false,
      isViewingContainmentHelp: false,

      directoryContents: `
      % pwd<br />
      /Users/username
      <br /><br />
      % ls - la<br />
      total 52<br />
      drwxr-xr-x&nbsp;&nbsp;&nbsp;&nbsp;5 username&nbsp;&nbsp;&nbsp;&nbsp;staff&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7348&nbsp;&nbsp;May&nbsp;3&nbsp;&nbsp;&nbsp;10:11 .<br />
      drwxr-xr-x&nbsp;&nbsp;&nbsp;&nbsp;5 username&nbsp;&nbsp;&nbsp;&nbsp;staff&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;748&nbsp;&nbsp;May&nbsp;3&nbsp;&nbsp;&nbsp;10:11 ..<br />
      -rw-------&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1 username&nbsp;&nbsp;&nbsp;&nbsp;staff&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2002&nbsp;&nbsp;May&nbsp;17&nbsp;&nbsp;2002&nbsp;&nbsp;&nbsp;.zsh_history<br />
      -rw-r--r--&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1 username&nbsp;&nbsp;&nbsp;&nbsp;staff&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1242&nbsp;&nbsp;May&nbsp;17&nbsp;&nbsp;2002&nbsp;&nbsp;&nbsp;.zsh_sessions<br />
      -rw-r--r--&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1 username&nbsp;&nbsp;&nbsp;&nbsp;staff&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;748&nbsp;&nbsp;May&nbsp;13&nbsp;&nbsp;10:12&nbsp;&nbsp;&nbsp;.zprofile<br />
      drwxr-xr-x&nbsp;&nbsp;&nbsp;&nbsp;11 username&nbsp;&nbsp;&nbsp;staff&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8442&nbsp;&nbsp;Oct&nbsp;23&nbsp;&nbsp;11:53&nbsp;&nbsp;&nbsp;Music<br />
      drwxr-xr-x&nbsp;&nbsp;&nbsp;&nbsp;7 username&nbsp;&nbsp;&nbsp;&nbsp;staff&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3340&nbsp;&nbsp;May&nbsp;3&nbsp;&nbsp;10:12&nbsp;&nbsp;&nbsp;HR<br />
      drwxr-xr-x&nbsp;&nbsp;&nbsp;&nbsp;7 username&nbsp;&nbsp;&nbsp;&nbsp;staff&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1334&nbsp;&nbsp;May&nbsp;3&nbsp;&nbsp;10:12&nbsp;&nbsp;&nbsp;Pictures<br />
      drwxr-xr-x&nbsp;&nbsp;&nbsp;&nbsp;3 username&nbsp;&nbsp;&nbsp;&nbsp;staff&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1124&nbsp;&nbsp;May&nbsp;3&nbsp;&nbsp;11:18&nbsp;&nbsp;&nbsp;DEV<br />
      drwxr-xr-x&nbsp;&nbsp;&nbsp;&nbsp;6 username&nbsp;&nbsp;&nbsp;&nbsp;staff&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3128&nbsp;&nbsp;May&nbsp;3&nbsp;&nbsp;11:48&nbsp;&nbsp;&nbsp;Public<br />
      -rw-r--r--&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1 username&nbsp;&nbsp;&nbsp;&nbsp;staff&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;132&nbsp;&nbsp;May&nbsp;3&nbsp;&nbsp;10:00&nbsp;&nbsp;&nbsp;userlist.txt<br />
      `,

      compensationReportContents: [
        ['April A', '12/4/2020', '234 South St', '4/1/2023', '46,909'],
        ['April W', '1/7/2012', '34553 North Brown Ave', '4/2/2023', '176,829'],
        ['Carolina P', '11/14/1999', '34 South St', '4/3/2023', '47,893'],
        ['Joe N', '1/6/2020', '904 W. Green St Apt 56', '1/7/2018', '189,990'],
        ['Sam W', '12/3/2001', '304 Circle Drive', '3/9/2020', '23,604'],
        ['Walter S', '6/12/2008', '1234 Isle Ave', '9/10/2022', '67,896'],
      ],

      userDataContents: [
        ['finance', 'money2023', '10.0.20.18', '4/3/2023', '5/8/2023'],
        ['adam', 'soccerStar', '145.24.0.15', '4/1/2023', '8/4/2016'],
        ['adam', 'baxter', '145.24.0.15', '4/2/2023', '6/6/2020'],
        ['april', 'Summer2012', '18.6.0.4', '4/3/2023', '5/8/2012'],
        ['caroline', 'pword', '147.0.20.45', '1/7/2018', '11/5/2014'],
        ['joe', 'football2015', '10.0.20.18', '4/3/2023', '3/1/2023'],
        ['sam', 'gRTok4', '140.0.28.15', '9/10/2022', '6/5/2020'],
        ['walter', 'starwars', '18.6.0.4', '4/3/2023', '1/5/2013'],
      ],

      weakPasswordQuestion: {
        value: [],
        correct: null,
        answer: ['Age', 'Expiration', 'Complexity', 'Length'],
      },
      containmentQuestion: {
        value: null,
        correct: null,
        answer: 'FIDO security key',
      },
    };
  },
  methods: {
    markSimulation() {
      let total_score = 0;

      for (const value of Object.values(this.weakPasswordQuestion.value)) {
        if (this.weakPasswordQuestion.answer.includes(value)) {
          total_score++;
        }
      }

      if (total_score === 4) {
        this.weakPasswordQuestion.correct = true;
      }

      if (this.containmentQuestion.value === this.containmentQuestion.answer) {
        total_score++;
        this.containmentQuestion.correct = true;
      } else {
        this.containmentQuestion.correct = false;
      }

      if (total_score === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', total_score);
      }
      this.$emit('simulation_getting_there', total_score);
      this.canShowHelp = true;
    },
  },
  components: {
    MovablePopup,
    LottieAnimation,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
